import { render, staticRenderFns } from "./PosOperationsTable.vue?vue&type=template&id=b331c5be&scoped=true&"
import script from "./PosOperationsTable.vue?vue&type=script&lang=js&"
export * from "./PosOperationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b331c5be",
  null
  
)

export default component.exports